/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/IsolatedPoolComptroller.json';
import { IsolatedPoolComptroller } from 'libs/contracts/generated/infos/contractTypes';
import { useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetIsolatedPoolComptrollerContractInput {
  address: string;
  signerOrProvider: Signer | Provider;
}

export const getIsolatedPoolComptrollerContract = ({
  signerOrProvider,
  address,
}: GetIsolatedPoolComptrollerContractInput) =>
  new Contract(address, abi, signerOrProvider) as IsolatedPoolComptroller;

interface UseGetIsolatedPoolComptrollerContractInput {
  passSigner: boolean;
  address: string;
  chainId?: ChainId;
}

export const useGetIsolatedPoolComptrollerContract = ({
  passSigner = false,
  address,
  chainId,
}: UseGetIsolatedPoolComptrollerContractInput) => {
  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getIsolatedPoolComptrollerContract({
            address,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, address],
  );
};
